// getUploadJobIds.js
'use strict';
import { Map } from 'immutable';

import createCachedSelector from '../resource/createCachedSelector.js';
import { ProfileListMediaType } from '../resource/profileConstants.js';

import getListData from '../selector/getListData.js';
import getOperationData from '../selector/getOperationData.js';

const defaultArray = [];
const defaultObject = {};
const defaultMap = new Map();
const defaultMediaTypeString = `${ProfileListMediaType.VIDEO},${ProfileListMediaType.IMAGE}`;

/**
 * Select upload job ids by upload job type
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} type - upload job type.
 * @param {string} mediaTypesString - media types string, like: video,image.
 * @return {array} Return upload jobs.
 */
const getUploadJobIds = createCachedSelector(
  state => getListData(state, ['uploadJob'], 'itemIds'),
  state => getOperationData(state, ['uploadJob']),
  state => state.get('assets'),
  (state, type) => type,
  (state, type, mediaTypesString) => mediaTypesString,
  (
    uploadJobIds = defaultArray,
    uploadJobObject = defaultObject,
    assetMap = defaultMap,
    type,
    mediaTypesString = defaultMediaTypeString
  ) => {
    const mediaTypes = mediaTypesString.split(',').filter(type => type);
    const hasWildcardInMediaTypes = mediaTypes.includes('*');
    return uploadJobIds.filter(uploadJobId => {
      const isUploadJobTypeMatched =
        uploadJobObject?.[uploadJobId]?.type === type;
      if (isUploadJobTypeMatched && hasWildcardInMediaTypes) {
        return true;
      }
      const firstAssetId = uploadJobObject?.[uploadJobId]?.assetIds?.[0];
      const isMediaTypeMatched = mediaTypes.some(mediaType =>
        assetMap
          .getIn([firstAssetId, 'contentType'])
          ?.toUpperCase()
          ?.startsWith(mediaType.toUpperCase())
      );
      return isUploadJobTypeMatched && isMediaTypeMatched;
    });
  }
)(
  (state, type, mediaTypesString = defaultMediaTypeString) =>
    `${type}:${mediaTypesString}`
);

export default getUploadJobIds;
